import React from 'react';
import { Button } from '@/components/ui/button';
import { Shield } from 'lucide-react';

export const SecuritySection = ({ 
  twoFaEnabled, 
  toggling2fa, 
  onToggle2fa 
}) => {
  return (
    <div className="bg-white/60 backdrop-blur-md border border-[#EAE4DC] shadow-lg rounded-2xl p-8">
      <div className="flex items-center space-x-3 mb-6">
        <Shield className="w-6 h-6 text-stone-600" strokeWidth={1.5} />
        <h2
          className="text-2xl font-medium"
          style={{ fontFamily: 'Playfair Display, serif' }}
        >
          Security
        </h2>
      </div>
      
      <div className="flex items-center justify-between">
        <div>
          <p className="font-medium text-stone-800">Two-Factor Authentication</p>
          <p className="text-sm text-stone-500">
            {twoFaEnabled 
              ? 'Your account is protected with 2FA' 
              : 'Add an extra layer of security'}
          </p>
        </div>
        <Button
          onClick={onToggle2fa}
          disabled={toggling2fa}
          variant={twoFaEnabled ? "outline" : "default"}
          className={`rounded-full px-6 ${twoFaEnabled ? '' : 'text-[#1A1A2E]'}`}
          style={twoFaEnabled ? {} : { backgroundColor: '#C9A84C' }}
          data-testid="toggle-2fa-button"
        >
          {(() => {
            if (toggling2fa) return '...';
            if (twoFaEnabled) return 'Disable';
            return 'Enable';
          })()}
        </Button>
      </div>
    </div>
  );
};
